import { render, staticRenderFns } from "./EmploymentDetails.vue?vue&type=template&id=62e1bbd5&"
import script from "./EmploymentDetails.vue?vue&type=script&lang=js&"
export * from "./EmploymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e1bbd5')) {
      api.createRecord('62e1bbd5', component.options)
    } else {
      api.reload('62e1bbd5', component.options)
    }
    module.hot.accept("./EmploymentDetails.vue?vue&type=template&id=62e1bbd5&", function () {
      api.rerender('62e1bbd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmploymentDetails.vue"
export default component.exports